import { component, getter, prop } from '../../decorators';

import VIDEO_ITEM_MIXIN from '../video-item.mixin';
import scrollIntoViewIfNeeded from '../../helpers/dom/scrollIntoViewIfNeeded';
import l10n from '@/transformers/l10n';
import {
   CLIPS_DOWNLOAD
} from '@/store/actions';

@component({
   mixins: [ VIDEO_ITEM_MIXIN ],
   watch: {
      isMouseIn: 'handleMouseMove'
   }
})
export default class VideoCard {
   @prop({ type: Boolean, default: true }) canOverlayed
   /** @type {Boolean} */
   isMouseIn = false
   hasActiveOptions = false

   get isOverlayed() {
      return this.canOverlayed && this.isMouseIn || this.hasActiveOptions;
   }

   get dialogue() {
      return this.isClip ? (this.info.dialogue || '').split('\n').join('<br>') : '';
   }

   @getter('getCurrentShowId') showId

   @getter() language

   toggleActiveOptions(isOpen) {
      this.hasActiveOptions = isOpen;
      this.$emit('active-options', isOpen);
   }

   handleMouseMove(isMouseIn) {
      if (!isMouseIn) {
         return;
      }
      setTimeout(() => {
         const { dialogue } = this.$refs;
         if (!dialogue) {
            return;
         }
         const el = dialogue.querySelector('em');
         if (el) {
            scrollIntoViewIfNeeded(el, false, 0, true);
         }
      }, 25);
   }

   download(clipId) {
      this.$store.dispatch(CLIPS_DOWNLOAD, { rootTitleId: this.showId, clipId, language: this.language });
   }

   get downloadTitle() {
      return l10n('cart.download_mxf');
   }
}
